import React from 'react';
import { useSelector } from 'react-redux';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { isFileCancel } from 'reactApp/modules/uploadList/uploadList.getters';
import { EFileError } from 'reactApp/modules/uploadList/uploadList.model';
import { getWarningFile } from 'reactApp/modules/uploadList/uploadList.selectors';
import { OverQuotaComponent } from 'reactApp/ui/UploadList/PopupWarnings/OverQuota';
import { OverWriteComponent } from 'reactApp/ui/UploadList/PopupWarnings/OverWrite';

export const PopupWarningsContainer = () => {
    const warningFile = useSelector(getWarningFile);
    const isPhone = EnvironmentSelectors.isPhone();
    let problem;

    if (!warningFile || isFileCancel(warningFile)) {
        return null;
    }

    switch (warningFile.error) {
        case EFileError.OVER_QUOTA_CLOUD: {
            problem = <OverQuotaComponent file={warningFile} isPhone={isPhone} />;
            break;
        }
        case EFileError.FILE_EXIST: {
            problem = <OverWriteComponent file={warningFile} isPhone={isPhone} />;
            break;
        }
    }

    if (!problem) {
        return null;
    }

    return <>{problem}</>;
};
